export const LAST_PAGE_KEY = 'SESSION_STORAGE:LAST_PAGE_KAY';

export const SSODomainRegexp = {
  development: new RegExp('^local.kampyle.com$', 'i'),
  qa: new RegExp('^[a-z0-9]+\\.qa\\.digital.medallia.com$', 'i'),
  production: new RegExp('^[a-z0-9]+\\.digital.medallia.com$', 'i'),
};

export const SSOStages = {
  PRE_SSO_AUTH: 'SSO_STAGE:PRE_AUTH',
  POST_SSO_AUTH: 'SSO_STAGE:POST_AUTH',
};

export const SSOStagesMessages = {
  [SSOStages.PRE_SSO_AUTH]:
    'Redirecting to SSO authentication endpoint please wait...',
  [SSOStages.POST_SSO_AUTH]: 'Initializing session please wait...',
};

export const ActionTypes = {
  SET_ERROR: 'APP:SET_ERROR',
  SET_SSO_STAGE: 'SSO:SET_STAGE',
  HANDLE_PRE_SSO_STAGE: 'SSO:HANDLE_PRE_SSO',
  HANDLE_POST_SSO_STAGE: 'SSO:HANDLE_POST_SSO',
  FETCH_SSO_ENDPOINT: 'SSO:FETCH_ENDPOINT',
  DO_SSO_AUTHENTICATION: 'SSO:AUTHENTICATE',
  LOGIN_TO_COMMAND_CENTER: 'MD:LOGIN_TO_COMMAND_CENTER',
  REDIRECT_TO_COMMAND_CENTER: 'MD:REDIRECT_TO_COMMAND_CENTER',
  HANDLE_COMMAND_CENTER_LOGIN_FAILURE: 'MD:HANDLE_COMMAND_CENTER_LOGIN_FAILURE',
};

export const JS_VALUES = {
  NULL: 'null',
  UNDEFINED: 'undefined',
};



// WEBPACK FOOTER //
// ./src/constants/index.js